<div class="msg-ai">
  <div class="ai-av">
    <mat-icon>{{ view.icon }}</mat-icon>
  </div>
  <div class="ai-card">
    <div class="turn-error-title">{{ view.title | translate }}</div>
    <div class="turn-error-message">{{ view.message | translate }}</div>
    @if (retryHintSeconds; as seconds) {
      <div class="turn-error-retry-hint">{{ 'Try again in {{seconds}}s.' | translate: { seconds } }}</div>
    }
    @if (view.canRetry) {
      <button type="button" class="retry-btn" (click)="onRetryClick()">
        <mat-icon>refresh</mat-icon>
        {{ 'Retry' | translate }}
      </button>
    }
  </div>
</div>
